import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, Toggle } from "material-ui"
import strings from "../../../localization/strings"
import { IScheduleTemplate, IJobDocument } from "../../../models"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import * as utils from "../../../helpers/utils"
import AccountStore from "../../../stores/AccountStore"
import * as scheduleHelper from "../../../helpers/scheduleHelper"
import ChooseHierarchyJobChip from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobChip"

interface IProps {
  handleClose(): void
  handleAdd(scheduleTemplate: IScheduleTemplate): void
}
interface IState {
  name: string
  errorName: string
  description: string
  hierarchyId: string
  jobId: string
  jobName: string
  periodDays: number
  errorPeriodDays: string
  excludeWeekends: boolean
}

export default class AddScheduleTemplateDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      name: "",
      errorName: "",
      description: "",
      hierarchyId: HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null,
      jobId: null,
      jobName: null,
      periodDays: 7,
      errorPeriodDays: "",
      excludeWeekends: false
    }
    autobind(this)
  }

  handleSave() {
    if (!this.checkValidate()) return
    const payload: IScheduleTemplate = {
      Id: utils.guid(),
      Name: this.state.name.trim(),
      Description: this.state.description,
      HierarchyId: this.state.hierarchyId,
      JobId: this.state.jobId,
      JobName: this.state.jobName,
      StartDate: scheduleHelper.getTimeFromSimpleTime(AccountStore.ScheduleVirtualSimpleTime).utc(true).format(),
      EndDate: scheduleHelper.getTimeFromSimpleTime(AccountStore.ScheduleVirtualSimpleTime).add(this.state.periodDays - 1, "day").endOf("day").utc(true).format(),
      PatternTemplates: [],
      ExcludeWeekends: this.state.excludeWeekends
    }
    this.props.handleAdd(payload)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.name.trim()) {
      this.setState({ errorName: strings.NameRequired })
      isValidate = false
    }
    else if (scheduleHelper.checkDuplicatedScheduleTemplateName(this.state.name, this.state.hierarchyId, this.state.jobId)) {
      this.setState({ errorName: strings.Name_is_duplicated })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (!this.state.periodDays) {
      this.setState({ errorPeriodDays: strings.This_field_is_required })
      isValidate = false
    }
    else {
      const dayLengthMinValue = 1
      if (this.state.periodDays < dayLengthMinValue || this.state.periodDays > 31) {
        this.setState({ errorPeriodDays: strings.formatString(strings.This_field_requires_a_number_between_min_and_max, dayLengthMinValue, 31) as string })
        isValidate = false
      }
      else {
        this.setState({ errorPeriodDays: "" })
      }
    }
    return isValidate
  }

  render() {
    return (
      <Dialog
        open={true}
        title={strings.New_Schedule_Template}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"menu-Schedules-ScheduleTemplates-Btn-CloseAddScheduleTemplateDialog"}
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"menu-Schedules-ScheduleTemplates-btn-SaveOrUpdateScheduleTemplate"}
            label={strings.SAVE}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <div style={{ width: "100%" }}>
            <TextField
              data-intercom-target={"menu-Schedules-ScheduleTemplates-Add-Entry-Name"}
              floatingLabelText={strings.Name}
              value={this.state.name}
              onChange={(e, value) => this.setState({ name: value }, () => this.checkValidate())}
              errorText={this.state.errorName}
              errorStyle={{ position: "absolute", bottom: -10 }}
              fullWidth={true}
            />
          </div>
          <div style={{ width: "100%" }}>
            <TextField
              data-intercom-target={"menu-Schedules-ScheduleTemplates-Add-Entry-SchedulePeriodDays"}
              floatingLabelText={strings.Schedule_Period_Days}
              value={this.state.periodDays}
              onChange={(e, value) => utils.validateInteger(value) && this.setState({ periodDays: value }, () => this.checkValidate())}
              errorText={this.state.errorPeriodDays}
              errorStyle={{ position: "absolute", bottom: -10 }}
              fullWidth={true}
            />
          </div>
          <div style={{ width: "100%" }}>
            <TextField
              data-intercom-target={"menu-Schedules-ScheduleTemplates-Add-Entry-Description"}
              floatingLabelText={strings.Description}
              value={this.state.description}
              onChange={(e, value) => this.setState({ description: value })}
              fullWidth={true}
            />
          </div>
          <Toggle
            data-intercom-target={"AddScheduleTemplate-Toggle-ExcludeWeekends"}
            label={strings.Exclude_Weekends}
            toggled={this.state.excludeWeekends}
            style={{ width: 225, marginTop: 25 }}
            onToggle={(e, value) => this.setState({ excludeWeekends: value })}
          />
          <div style={{ marginTop: 20 }}>
            <ChooseHierarchyJobChip
              readonlyHierarchy
              hideJob={!AccountStore.getJobsEnabled()}
              hierarchyChipLabel={strings.HierarchyLevel}
              jobChipLabel={strings.Job}
              hierarchyItemId={this.state.hierarchyId}
              jobId={this.state.jobId}
              hieararchyChipMaxWidth={700}
              jobChipMaxWidth={700}
              handleSelectHierarchyJob={(hierarchyItemId: string, job: IJobDocument) => {
                this.setState({ jobId: job ? job.Id : null, jobName: job ? job.Name : null })
              }}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}